import CoursesGrid from '@sayyesschool/frontend/components/courses-grid';
import MaterialsGrid from '@sayyesschool/frontend/components/materials-grid';
import Page from '@sayyesschool/frontend/components/page';
import { useCourses } from '@sayyesschool/frontend/features/courses';
import { useMaterials } from '@sayyesschool/frontend/features/materials';
import { useVocabularies, VocabulariesGrid } from '@sayyesschool/frontend/features/vocabularies';

export default function HomePage() {
    const [courses] = useCourses();
    const [materials] = useMaterials();
    const [vocabularies] = useVocabularies();

    return (
        <Page className="HomePage">
            <Page.Content>
                <Page.Section
                    title="Курсы"
                    compact
                    plain
                >
                    <CoursesGrid courses={courses} />
                </Page.Section>

                <Page.Section
                    title="Материалы"
                    compact
                    plain
                >
                    <MaterialsGrid materials={materials} />
                </Page.Section>

                <Page.Section
                    title="Словари"
                    compact
                    plain
                >
                    <VocabulariesGrid vocabularies={vocabularies} />
                </Page.Section>
            </Page.Content>
        </Page>
    );
}